<template>
<div class="row">

	<div class="col-12">

		<div class="row">
			<div class="col-md-12">
				<h1 class="display-4">Cliënten</h1>
			</div>
		</div>

		<!-- Filter section -->
		<div class="mb-4 row">
			<div class="col-6">
				<general-input
					v-model="filters.bid_number"
					label="Biednummer"
					placeholder="Zoek op biednummer"
				/>
			</div>

			<div class="col-6">
				<general-input
					v-model="filters.name"
					label="Naam"
					placeholder="Zoek op naam"
				/>
			</div>
		</div>

		<div class="row">
			<div class="col-12 d-flex justify-content-end">
				<b-pagination-nav :link-gen="linkGen"
				                  :number-of-pages="persons.last_page"
				                  :value="persons.current_page"
				                  use-router
				                  align="right" />
			</div>
		</div>

		<b-alert v-if="error"
		         variant="danger"
		         show>{{ error }}</b-alert>

		<partial-loader :loading="isFetching"></partial-loader>

		<b-table v-if="!isFetching"
				 
				striped
				hover
				show-empty
				:items="persons.data"
				:fields="fields"
				:per-page="parseInt(persons.per_page)"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:busy="isFetching"
				:empty-text="$t('buyer.listEmptyText')"
				:empty-filtered-text="$t('buyer.listEmptyFilteredText')">

			<template v-slot:cell(actions)="row">
	 			<b-btn-group class="pull-right">
					<b-btn variant="outline-primary" :to="{ name: 'auctionBuyer', params: { bidNumber: row.item.bid_number }, query: { back: 'auctionBuyers' } }"><i class="fa fa-fw fa-eye"></i></b-btn>
				</b-btn-group>
	 		</template>

			<template slot="name"
			          slot-scope="row">
				<span v-if="row.item.buyer">{{ row.item.buyer.full_name }}</span>
				<span v-else class="font-italic">{{ $t('buyer.noPerson') }}</span>
	 		</template>

			<template slot="email"
			          slot-scope="row">
				<span v-if="row.item.buyer">{{ row.item.buyer.email }}</span>
			</template>

		</b-table>

		<b-pagination-nav :link-gen="linkGen"
		                  :number-of-pages="persons.last_page"
		                  :value="persons.current_page"
		                  use-router
		                  align="right" />
	</div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import AuctionService from '@/services/auction-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import { isCancel, CancelToken } from 'axios';
import GeneralInput from '../../../elements/Input/GeneralInput';
import RequestHelper from '@/helpers/request-helper';

const requestHelper = new RequestHelper();

export default {
	components: {
		PartialLoader,
		GeneralInput
	},
	data() {
		return {
			isFetching: true,
			persons: {},
			error: null,
			fields: [
				{ key: 'bid_number', label: this.$t('bid.bidNumber') },
				{ key: 'buyer.full_name_simple', label: this.$t('common.name') },
				{ key: 'buyer.email', label: this.$t('common.email') },
				{ key: 'auction_bids', label: this.$t('buyer.bidsCount') },
				{ key: 'actions', label: 'Acties' }
			],
			currentPage: 1,
			perPage: 50,
			filter: '',
			sortBy: 'id',
			sortDesc: true,
			cancelToken: null,


			filters: {
				bid_number: this.$route.query.bid_number,
				name: this.$route.query.name,
			}
		}

	},
	watch: {
		'filters': {
			handler: function (val, oldVal) {
				this.filterData();
			},
			deep: true,
		},
		'$route': 'fetchData'
	},
	methods: {
		initialize() {
			this.fetchData();
		},
		linkGen(pageNumber) {
			return `?page=${pageNumber}`;
		},
		genUrl() {
			return `${this.genAuctionUrl()}/buyers?page=1&filter=${this.filter}`;
		},
		genAuctionUrl() {
			return `/auction/${this.$route.params.auctionId}`;
		},
		filterData() {
			this.$router.push({ query: {
				..._.pickBy(this.filters, _.identity),
			}});
		},
		fetchData() {
			this.isFetching = true;

			const query = this.$route.query;
			const currentPage = Number.parseInt(query.page);
			this.currentPage = isNaN(currentPage) ? 1 : currentPage;

			if (!isNil(this.cancelToken)) {
				this.cancelToken.cancel();
			}

			this.cancelToken = CancelToken.source();

			const params = {
				total: this.perPage,
				page: this.currentPage,
				sort: 'number',
				order: 'asc',
				...query
			}

			return AuctionService.getAuctionBuyers(this.$route.params.auctionId, params, this.cancelToken.token).then(response => {
				this.isFetching = false;
				this.persons = response;
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		},
		setQuery() {
			if (this.$route.query.filter)
				this.filter = this.$route.query.filter;
		},
	},
	mounted() {
		this.setQuery();
		this.initialize();
	}
}
</script>



// WEBPACK FOOTER //
// BuyerList.vue?902defe2